// extracted by mini-css-extract-plugin
export default {"cls1":"YOqsFsr_dQnSGxLDVJGA","cls2":"arETQttJrxy4FOryYEwq YOqsFsr_dQnSGxLDVJGA"};